// Copyright © 2022 CATTLEytics Inc.

/**
 * WARNING!
 *
 * DO NOT EDIT THIS FILE
 *
 * CHANGES WILL BE OVERWRITTEN!
 *
 * Make changes in packages/shared and run npm run copy-shared-to-packages
 */

/**
 * Animal Event Type Enumerations
 *
 * Note: these types mapped 1:1 to the system defined rows in animal_events_type table.
 */
export enum AnimalEventType {
  Arrival = 1,
  Sold = 2,
  Pregnant = 3,
  Move = 4,
  Diagnosis = 5,
  Fresh = 6,
  Bred = 7,
  Abort = 9,
  Died = 10,
  DriedOff = 11,
  Open = 12,
  Calving = 13,
  Recheck = 41,
  Check = 485,
  Heat = 493,
  Mastitis = 478,
}
